import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const DetailStatCardSkeleton = () => {
  return (
    <Skeleton
      height="100%"
      width="100%"
      borderRadius="1rem"
      containerClassName="block h-[100px] w-full"
    />
  );
};

export default DetailStatCardSkeleton;
